<template lang="html">
  <div class="slider">


  <div class="overlayt" @click="preventClose">
    <div class="popupt sliders" @click="preventClose">

      <!-- <div class="container"> -->
        <!-- <img src="static/imgs/kopce.jpgg" alt="Avatar" class="image"> -->
        <!-- <div class="overlay"> -->


        <!-- </div> -->

      <!-- </div> -->
      <div class="slideshow-container">
            <div class="mySlides fade" v-for="(pro,index) in propics">
            <div class="numbertext">{{index+1}} / {{propics.length}}</div>
            <img :src="prourl+pro.sl_id"  alt=""  >
            </div>

            <a class="prev" @click="plusSlides(-1)">&#10094;</a>
            <a class="next" @click="plusSlides(1)">&#10095;</a>

    </div>
      <br>

      <div style="text-align:center"  >
        <div class="" v-for="(pro,index) in propics">
          <span class="dot" @click="currentSlide(index)"></span>

          <!-- <img :src="prourl+pro.sl_id"  alt=""  > -->
        </div>
        <div class="text">{{getproname}}</div>
          <!-- <span class="dot" @click="currentSlide(2)"></span>
          <span class="dot" @click="currentSlide(3)"></span> -->
      </div>
      <button type="button" name="button" @click="setterms(false)"><i class="fa fa-close"></i>Zatvori</button>
    </div>

  </div>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
export default {
  data(){
    return{
      slideIndex: 0,

    }
  },
  computed:{
    ...mapGetters([
      'propics',
      'prourl',
      'getproname'

    ]),

  },
  created(){

  },
methods:{
  ...mapMutations([
    'setterms'

  ]),
  ...mapActions([
      'getpropics',

  ]),
  preventClose (e) {
      			e.stopPropagation()
      		},

      plusSlides(n) {
        this.showSlides(this.slideIndex += n);
      },

      currentSlide(n) {
        this.showSlides(this.slideIndex = n);
      },

      showSlides(n) {
        var i;
        var slides = document.getElementsByClassName("mySlides");
        // console.log('slides', slides);
        var dots = document.getElementsByClassName("dot");
        // console.log('dots', dots);
        if (n > this.propics.length-1) {
          this.slideIndex = 0
        }
        if (n <0) {
          this.slideIndex = slides.length-1
        }
        for (i = 0; i < this.propics.length; i++) {
            slides[i].style.display = "none";
        }
        for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active2", "");
        }
        slides[this.slideIndex].style.display = "block";
        dots[this.slideIndex].className += " active2";
      }

},


  mounted(){
    // if(this.propics !==""){
    // this.showSlides(this.slideIndex);
    // }


  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/slide.vue